// mocks/notificacoes.js
const notificacoes = Array.from({ length: 100 }, (_, i) => ({
	id: i + 1,
	unidade:
		i % 3 === 0
			? 'Hospital Maluquete'
			: i % 3 === 1
			? 'UPA Central'
			: 'Clínica Popular',
	numero: `${String(i + 1).padStart(4, '0')}/2024`,
	nome: ['Maria da Silva', 'João Pereira', 'Ana Souza', 'Carlos Lima'][i % 4],
	agravo: [
		'Falha operacional',
		'Infecção hospitalar',
		'Erro de medicação',
		'Acidente com equipamento',
	][i % 4],
	data: `2024-${String((i % 12) + 1).padStart(2, '0')}-${String(
		(i % 28) + 1
	).padStart(2, '0')}`,
	status: ['Aguardando investigação', 'Aguardando conclusão', 'Concluído'][
		i % 3
	],
}));

export default notificacoes;
